import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/** Each word must start with a letter; letters and digits allowed after the first character. */
export const FULL_NAME_PATTERN = /^[a-zA-Z][a-zA-Z0-9]*(\s+[a-zA-Z][a-zA-Z0-9]*)*$/;

export function isValidFullName(value: string): boolean {
  const trimmed = (value ?? '').trim();
  if (!trimmed) {
    return false;
  }
  return FULL_NAME_PATTERN.test(trimmed);
}

export function fullNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value ?? '').trim();
    if (!value) {
      return null;
    }
    return isValidFullName(value) ? null : { invalidFullName: true };
  };
}

export const FULL_NAME_VALIDATION_MESSAGE =
  'Full name must start with a letter. After that, you may use letters and numbers.';
